import api from './client';

export async function subscribe(email, name, eventId) {
  const { data } = await api.post('/api/newsletter/subscribe', { email, name, eventId });
  return data;
}
